import React, { Component } from 'react';

class ProvinceInput extends Component {
  render() {
    const { name, year, value } = this.props;

    if(value) {
      return (
        <div className="sl-stat-row">
          <div className="sl-stat-label-wrap">
            <span className="sl-stat-label">{name}</span>
            <span className="sl-stat-year-badge">{year}</span>
          </div>
          <div className="sl-stat-right">
            <span className="sl-stat-val">{value}</span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default ProvinceInput;
